import { CanMatchFn, Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { APP_PATHS } from '../config/app-paths';
import { ApplicationContextService } from '../services/application-context.service';

export const AuthAdminGuard: CanMatchFn = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const applicationContextService = inject(ApplicationContextService);
  const router = inject(Router);
  return authService.checkAndHandleAdminSession$().pipe(
    tap((hasSession: boolean) => {
      const hasSessionAndAdminContext =
        hasSession && applicationContextService.isAdminContext();

      if (hasSessionAndAdminContext) {
        return true;
      } else if (hasSession) {
        router.navigate([APP_PATHS.home]);
        return false;
      } else {
        router.navigate([APP_PATHS.auth.root, APP_PATHS.auth.loginMethod]);
        return false;
      }
    }),
  );
};
